module.exports = __webpack_public_path__ + "img/Dantam Bridal 24.c65b5ab4.jpg";